var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongHandleSearch = function SvgLongHandleSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9785_8306)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    d: "M12.763 23.013c2.275 0 4.5-.763 6.287-2.163l6.788 6.787a1.27 1.27 0 0 0 1.8-.037c.475-.5.475-1.275 0-1.775l-6.788-6.787c3.475-4.475 2.663-10.925-1.812-14.4s-10.9-2.65-14.375 1.825-2.675 10.924 1.8 14.4c1.8 1.4 4.012 2.162 6.3 2.162zm-5.45-15.7a7.703 7.703 0 0 1 10.9 0 7.703 7.703 0 0 1 0 10.9 7.703 7.703 0 0 1-10.9 0C4.3 15.224 4.288 10.362 7.275 7.35z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9785_8306"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 2.5H28V28H2.5z"
  })))));
};
export default SvgLongHandleSearch;